import Widget from "../../components/widget";
import {Button} from "../../components/My/Button";
import React, {useEffect, useState} from "react";
import {apiGetConnections} from "./Actions";
import TableData from "./TableData";



const Connections = () => {
    const [loading, setLoading] = useState(false)
    const [data, setData] = useState(null)

    useEffect(() => {
        getConnections()
    }, [])

    const getConnections = () => {
        setLoading(true)
        apiGetConnections((data) => {
            setData(data)
            setLoading(false)
        }, (err) => {
            setLoading(false)
        })
    }

    return (
        <>
            <Widget>
                <div className={"flex flex-row text-black"}>
                    <h5 className={"align-middle"}>Připojení</h5>
                    <span className="ml-auto"></span>
                    <div className={"flex"}>
                        <Button text={"Přidat připojení"} link={"/connections/add"}/>
                    </div>
                </div>
            </Widget>
            <TableData data={data} loading={loading}/>
        </>
    )

}

export default Connections